<ng-container *ngIf="eventLabel">
    <button dssButton (click)="actionClick.emit(true)"  class="button-link"
    trackingClick [eventLabel]="eventLabel" id="{{elementId}}">{{text}}</button>
</ng-container>

<ng-container *ngIf="!eventLabel">
    <button dssButton (click)="actionClick.emit(true)"  class="button-link" id="{{elementId}}">{{text}}</button>
</ng-container>
